import { render } from "./ApplyOpenPbb.vue?vue&type=template&id=2702c839"
import script from "./ApplyOpenPbb.vue?vue&type=script&lang=js"
export * from "./ApplyOpenPbb.vue?vue&type=script&lang=js"
script.render = render

export default script